export function presenceSql(actor){
 if(!/^[1-9]\d{0,14}$/.test(String(actor)))throw new Error('Invalid actor');
 return `WITH actor AS(SELECT id FROM uogorod.users WHERE id=${actor} AND account_deleted_at IS NULL),
 touched AS(INSERT INTO uogorod_presence.visits(user_id,last_seen_at) SELECT id,now() FROM actor
 ON CONFLICT(user_id) DO UPDATE SET last_seen_at=EXCLUDED.last_seen_at
 WHERE visits.last_seen_at<now()-interval '5 minutes' RETURNING user_id)
 SELECT jsonb_build_object('active',EXISTS(SELECT 1 FROM actor),'recorded',EXISTS(SELECT 1 FROM touched));`;
}
export function peopleSort(value){
 if(value==='name')return {key:'name',order:"lower(COALESCE(NULLIF(name,''),nickname)) ASC NULLS LAST,id"};
 if(value==='created_at')return {key:'created_at',order:'created_at DESC NULLS LAST,id DESC'};
 if(value==='last_seen'||value==='updated_at')return {key:'last_seen',order:'last_seen_at DESC NULLS LAST,id DESC'};
 // Preserve older links without confusing publication activity and authenticated visits.
 return {key:'publications',order:'publications_at DESC NULLS LAST,id DESC'};
}
export function visitLabel(value){
 if(!value)return '';
 const date=new Date(value);if(!Number.isFinite(date.getTime()))return '';
 return new Intl.DateTimeFormat('ru-RU',{timeZone:'Europe/Moscow',day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'}).format(date)+' МСК';
}
